export default "__VITE_ASSET__cfedbd8b__"